import { Component, Input} from '@angular/core';

@Component({
    selector: 'app-manipulation-status',
    template: `
<span class="badge"
    [class.text-bg-secondary]="code == 'Submitted'"
    [class.text-bg-light]="code == 'Draft'"
    [class.text-bg-success]="code == 'APST'"
    [class.text-bg-warning]="code == 'ATC'"
    [class.text-bg-danger]="code == 'NOR'">
{{text || ('manipulation_status' + code | translate)}}
</span>
`
})
export class ManipulationStatusComponent {
    @Input() code: string;
    @Input() text: string;
}
